<template>
  <div class="w-full h-full">
    <router-view v-if="hasRequiredPermissions" />

    <no-permissions v-else />
  </div>
</template>

<script>
import permissionMixin from '@/mixins/permissionMixin'
import NoPermissions from '@/views/no-permissions.vue'

export default {
  components: {
    'no-permissions': NoPermissions
  },
  mixins: [permissionMixin],
  computed: {
    token() {
      return this.$store.state.applicationState.token
    },
    associate() {
      return this.$store.state.applicationState.associate
    },

    requiredPermissions() {
      return this.$route.meta?.permissions
        ? Array.isArray(this.$route.meta.permissions)
          ? this.$route.meta.permissions
          : [this.$route.meta.permissions]
        : null
    },

    hasRequiredPermissions() {
      if (this.associate && !this.hasAdminGroup && this.token && this.$route.path !== '/kpi') {
        this.$router.replace({ name: 'kpi' }).catch(() => {})
        return false
      }

      if (this.requiredPermissions) {
        return this.requiredPermissions.some(perm => this.associate?.permissions?.some(p => p.name === perm))
      }

      return true
    }
  }
}
</script>
